
import Vue from "vue";
import i18n from './i18n'
import { extend, configure, ValidationProvider, ValidationObserver, defineRule } from "vee-validate";
import { required, email, min, max, integer, regex, size, ext } from "vee-validate/dist/rules";

extend('required', required)
extend('email', email)
extend('min', min)
extend('max', max)
extend('integer', integer)
extend('regex', regex)
extend('size', size)
extend('ext', ext)

extend('minmax', (value, [min, max]) => {
  // The field is empty so it should pass
  if (!value || !value.length) {
    return true;
  }
  const numericValue = parseFloat(value);
  if (numericValue < min) {
    return i18n.t(`validation.min_value`, {min: min})
  }

  if (numericValue > max) {
    return i18n.t(`validation.max_value`, {max: max})
  }
  return true;
});

extend('noerrors', (value) => {
  if (value > 0) {
    return i18n.t(`validation.noerrors`, {number: value})
  }
  return true;
});

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, { attribute : i18n.t(field), ...values } )
  }
})


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);